import { FormCheck } from 'react-bootstrap';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import type { FormCheckType } from 'types/common';
import classlist from 'utils/classlist';
import './style.scss';

interface CheckboxProps<T = boolean | FormCheckType> extends FormGroupProps<T> {
    label: React.ReactNode;
    className?: string;
    name: string;
    hideError?: boolean;
}

/**
 * @description 统一封装的Checkbox组件，具有特定的样式，一般用于协议/条款确认勾选等地方
 * 此组件不包含特殊的业务逻辑
 */
const Checkbox: <T>(
    props: React.PropsWithChildren<CheckboxProps<T>> & {
        disabled?: boolean;
    }
) => React.ReactElement<any, any> = props => {
    const { label, className, name, disabled, hideError = true, ...restProps } = props;

    return (
        <FormGroup
            className={classlist(
                'checkbox-root',
                {
                    'hide-error': hideError
                },
                className
            )}
            name={name}
            errorLevel={1}
            {...restProps}>
            <FormCheck disabled={disabled} className="checkbox-form-check" id={name} type="checkbox" label={label} />
        </FormGroup>
    );
};

export default Checkbox;
